<template>
  <div :id="id"></div>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      chart: null,
      defaultOpt: {
        // grid: {
        //   left: '60',
        //   top: '50',
        //   right: '30',
        //   bottom: '50'
        // }
      }

    }
  },
  watch: {
    option: {
      handler(newVal, oldVal) {
        if (this.chart) {
          if (newVal !== oldVal) {
            this.chart.clear();
            this.chart.setOption({
              ...this.defaultOpt, ...this.option
            })
          }
        } else {
          this.init()
        }
      },
      deep: true
    }
  },

  mounted() {
    let _this = this
    window.onresize = function () {
      _this.chart.resize()
    }
  },
  created() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.chart = this.$echarts.init(document.getElementById(this.id))
      this.chart.setOption({
        ...this.defaultOpt, ...this.option
      });
    }
  }

}
</script>

<style>
</style>
